export const channelViewStyles = {
  display: 'flex',
  flexDirection: 'column',
  width: '400px',
  height: '560px',
  minHeight: 0,
  overflow: 'hidden',
};

export const channelViewHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '10px 12px',
  borderBottom: ({ palette }) => `1px solid ${palette.border.light}`,
  flexShrink: 0,
};

export const channelViewTitleWrapperStyles = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
};
